import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgPauseIcon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
      <path
        d="M38.899 67.5H25.523a2 2 0 0 1-2-2v-41a2 2 0 0 1 2-2h13.376a2 2 0 0 1 2 2v41a2 2 0 0 1-2 2Zm-11.376-4h9.376v-37h-9.376v37Z"
        fill="currentColor"
      />
      <path
        d="M64.477 67.5H51.101a2 2 0 0 1-2-2v-41a2 2 0 0 1 2-2h13.376a2 2 0 0 1 2 2v41a2 2 0 0 1-2 2Zm-11.376-4h9.376v-37h-9.376v37Z"
        fill="currentColor"
      />
      <path
        d="M45 90C20.187 90 0 69.813 0 45 0 20.187 20.187 0 45 0s45 20.187 45 45c0 24.813-20.187 45-45 45Zm0-86C22.393 4 4 22.393 4 45s18.393 41 41 41 41-18.393 41-41S67.607 4 45 4Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const ForwardRef = forwardRef(SvgPauseIcon);
export default ForwardRef;
